import { render, staticRenderFns } from "./LogManagementTable.vue?vue&type=template&id=39abcbf2&"
import script from "./LogManagementTable.vue?vue&type=script&lang=js&"
export * from "./LogManagementTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports